import React from "react";
import SideBar from "./SideBar";
import { Outlet } from "react-router";
import Head from "./Head";

const Body = () => {
  return (
    <>
      <Head />
      <div className="flex">
        <SideBar />
        <Outlet />
      </div>
    </>
  );
};

export default Body;
